import { render, staticRenderFns } from "./WsInfoSection.vue?vue&type=template&id=784c14b0&"
import script from "./WsInfoSection.vue?vue&type=script&lang=js&"
export * from "./WsInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./WsInfoSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
